<template>
  <div id="servitor">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Servitor'
};
</script>

<style lang="less" scoped>
#servitor {
  overflow: hidden;
  position: relative;
  width: 100%;
  // min-width: 320px;
  // max-width: 750px;
  height: 100vh;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/servitor/App.vue